export default [
  {
    path: '/real-estate-developments-settings/insurance-companies',
    name: 'InsuranceCompaniesList',
    component: () => import('pages/real-estate-developments-settings/insurance-companies/InsuranceCompaniesList.vue')
  },
  {
    path: '/real-estate-developments-settings/insurance-companies/new',
    name: 'InsuranceCompaniesCreate',
    component: () => import('pages/real-estate-developments-settings/insurance-companies/InsuranceCompaniesForm.vue')
  },
  {
    path: '/real-estate-developments-settings/insurance-companies/:id/edit',
    name: 'InsuranceCompaniesEdit',
    component: () => import('pages/real-estate-developments-settings/insurance-companies/InsuranceCompaniesForm.vue')
  },
  {
    path: '/real-estate-developments-settings/insurance-companies/:id',
    name: 'InsuranceCompaniesSingle',
    component: () => import('pages/real-estate-developments-settings/insurance-companies/InsuranceCompaniesSingle.vue')
  }
]
